import { CancellationEndpoint } from '@acorn-portal/shared/src/pages/cancellation/types';
import { validateJourneyCompletion } from './validate-journey-completion';
import { validateStepIndex } from './validate-step-index';

/**
 * Validate the current step in the cancellation process
 * @param currentStep - The current step in the cancellation process
 * @param stepCeiling - The maximum step the user can access
 * @param takenUp - Whether the user has taken up the policy
 * @returns Whether the current step is valid
 */
export const validateStep = (
	currentStep: CancellationEndpoint | undefined,
	stepCeiling: CancellationEndpoint | undefined,
	takenUp: boolean,
) => {
	// If there isn't a current step or step ceiling, they're attempting access from an invalid state - redirect
	if (!currentStep || !stepCeiling) return false;
	// If they aren't up to that point in the journey - redirect
	const validIndex = validateStepIndex(currentStep, stepCeiling);
	if (!validIndex) return false;
	// If their takeup status doesn't marry up - redirect
	const validJourneyCompletion = validateJourneyCompletion(currentStep, takenUp);
	if (!validJourneyCompletion) return false;
	return true;
};
